import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useHover } from '@costar-ui/hooks';
import { filterUndefined, mergeRefs } from '@costar-ui/utils';
import React__default, { forwardRef, useEffect, useMemo } from 'react';
import CardBody from './card-body/card-body.esm.js';
import CardContextProvider from './card-context/card-context.esm.js';
import CardFooter from './card-footer/card-footer.esm.js';
import CardHeader from './card-header/card-header.esm.js';
import CardImage from './card-image/card-image.esm.js';
import CardSlot from './card-slot/card-slot.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import { useComponentVariant } from '../../theme/variant.context.esm.js';
import { usePopoverContext } from '../popover/popover-context.esm.js';

var _excluded = ["variant", "onHoverStateChanged"],
  _excluded2 = ["bordered", "children", "className", "direction", "canShrink", "fullWidth", "fullHeight", "fontFamily", "fontSize", "color", "radius", "shadow", "padding", "withDivider", "inheritFontSize"];
var CardRoot = /*#__PURE__*/forwardRef(function CardRoot(_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'std-border-divider' : _ref$variant,
    onHoverStateChanged = _ref.onHoverStateChanged,
    props = _objectWithoutProperties(_ref, _excluded);
  var variantProps = useComponentVariant('Card', variant);
  var theme = useComponentTheme('Card');
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    isHover = _useHover2[0],
    cardRef = _useHover2[1];
  var popoverContext = usePopoverContext();
  var _variantProps$filterU = _objectSpread2(_objectSpread2(_objectSpread2({}, variantProps), filterUndefined(popoverContext || {})), props),
    bordered = _variantProps$filterU.bordered,
    children = _variantProps$filterU.children,
    _variantProps$filterU2 = _variantProps$filterU.className,
    className = _variantProps$filterU2 === void 0 ? '' : _variantProps$filterU2,
    _variantProps$filterU3 = _variantProps$filterU.direction,
    direction = _variantProps$filterU3 === void 0 ? 'vertical' : _variantProps$filterU3,
    canShrink = _variantProps$filterU.canShrink,
    fullWidth = _variantProps$filterU.fullWidth,
    fullHeight = _variantProps$filterU.fullHeight,
    fontFamily = _variantProps$filterU.fontFamily,
    fontSize = _variantProps$filterU.fontSize,
    color = _variantProps$filterU.color,
    radius = _variantProps$filterU.radius,
    shadow = _variantProps$filterU.shadow,
    padding = _variantProps$filterU.padding,
    withDivider = _variantProps$filterU.withDivider,
    inheritFontSize = _variantProps$filterU.inheritFontSize,
    rest = _objectWithoutProperties(_variantProps$filterU, _excluded2);
  useEffect(function () {
    onHoverStateChanged === null || onHoverStateChanged === void 0 || onHoverStateChanged(!!isHover);
  }, [isHover, onHoverStateChanged]);
  // const id = usePropId(props.id)

  var contextValue = useMemo(function () {
    return {
      radius: radius,
      padding: padding,
      withDivider: withDivider
    };
  }, [radius, padding, withDivider]);
  var classes = useMemo(function () {
    return theme.root({
      bordered: bordered,
      canShrink: canShrink,
      className: className,
      color: color,
      direction: direction,
      fontFamily: fontFamily,
      fontSize: fontSize,
      fullHeight: fullHeight,
      fullWidth: fullWidth,
      inheritFontSize: inheritFontSize,
      radius: radius,
      shadow: shadow,
      withDivider: !!withDivider
    });
  }, [bordered, canShrink, className, color, direction, fontFamily, fontSize, fullHeight, fullWidth, inheritFontSize, radius, shadow, theme, withDivider]);
  return /*#__PURE__*/React__default.createElement(CardContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React__default.createElement("div", _extends({
    // id={id}
    ref: mergeRefs(ref, cardRef),
    className: "csg-tw-card-root ".concat(classes),
    "data-rec": ""
  }, isHover ? {
    'data-hovered': ''
  } : {}, rest), children));
});
var Card = Object.assign(CardRoot, {
  Body: CardBody,
  Footer: CardFooter,
  Header: CardHeader,
  Image: CardImage,
  Slot: CardSlot
});
Card.displayName = 'Card';
var Card$1 = Card;

export { Card$1 as default };
//# sourceMappingURL=card.esm.js.map
